import Slider from 'components/slider-class.js';
import Utils from 'core-helpers/utils.js';

const sliders = Utils.getElementsByClass('js-slider');
sliders.forEach((item) => new Slider(item));
